import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const changeWholesalerStatus = async (
  id: number,
  status: "disable" | "enable"
) =>
  axios.put(Routes.WHOLESALERS + "/" + id + "/" + Routes.WHOLESALERS_STATUS, {
    status,
  });

export const useChangeWholesalerStatus = (
  id: number,
  status: "disable" | "enable"
) =>
  useMutation({
    mutationKey: [Keys.CHANGE_FACTOR_STATUS_MUT],
    mutationFn: () => changeWholesalerStatus(id, status),
  });
